import type { ToolId } from '../config/toolConfig';
import { AutoSalvageFleet } from './AutoSalvageFleet';
import { InflatableBoat } from './InflatableBoat';
import { LifeRing } from './LifeRing';
import { LifeVest } from './LifeVest';
import { RescuePole } from './RescuePole';
import { RescueRope } from './RescueRope';
import type { RescueTool } from './RescueTool';

export function createRescueTool(id: ToolId): RescueTool {
  switch (id) {
    case 'lifeRing':
      return new LifeRing();
    case 'rope':
      return new RescueRope();
    case 'lifeVest':
      return new LifeVest();
    case 'rescuePole':
      return new RescuePole();
    case 'inflatableBoat':
      return new InflatableBoat();
    case 'autoSalvage':
      return new AutoSalvageFleet();
  }
}
